import { CreateOrgUnit } from '~/domain/usecases/orgUnit/remote';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import {
  InvalidCredentialsError,
  UnexpectedError,
  BadRequestError,
  NotFound,
  Forbidden,
} from '~/domain/errors';
import '~/infra/global/variables';

export class RemoteCreateOrgUnit implements CreateOrgUnit {
  private readonly url: string;

  private readonly httpClient: HttpClient<CreateOrgUnit.Model>;

  constructor(url: string, httClient: HttpClient<CreateOrgUnit.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  create = async (
    params: CreateOrgUnit.Params,
  ): Promise<CreateOrgUnit.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'post',
      body: params,
    });
    console.log('response: ', httpResponse);
    console.log('params', params);
    console.log('url: ', this.url);
    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      case HttpStatusCode.notFound:
        throw new NotFound();
      default:
        throw new UnexpectedError();
    }
  };
}
